import { createSelector } from 'reselect';
import { jwtDecode } from '../helpers/jwt';
import { sinceEpoch } from '../helpers/date';
import moment from 'moment';

const stateSessionSelector = (state) => state.session;

const jwtSelector = createSelector(
    [stateSessionSelector],
    (session) => {
        if (!session.token) return {};
        return jwtDecode(session.token);
    }
);

const refreshJwtSelector = createSelector(
    [stateSessionSelector],
    (session) => {
        if (!session.refresh) return {};
        return jwtDecode(session.refresh);
    }
);

const sessionPolicySelector = createSelector(
    [jwtSelector],
    (jwt) => {
        if (jwt.payload && jwt.payload.pol){
            if (!Array.isArray(jwt.payload.pol)) return [jwt.payload.pol];
            return jwt.payload.pol;
        }
        return [];
    }
);

const sessionUserSelector = createSelector(
    [jwtSelector],
    (jwt) => {
        let user = {};
        if (jwt.payload && jwt.payload.given_name) user.firstName = jwt.payload.given_name;
        if (jwt.payload && jwt.payload.family_name) user.lastName = jwt.payload.family_name;
        if (jwt.payload && jwt.payload.full_name) user.name = jwt.payload.full_name;
        if (jwt.payload && jwt.payload.locale) user.locale = jwt.payload.locale;
        if (jwt.payload && jwt.payload.email_address) user.email = jwt.payload.email_address;
        return user;
    }
);

export const sessionSelector = createSelector(
    [stateSessionSelector, jwtSelector, refreshJwtSelector, sessionPolicySelector, sessionUserSelector],
    (session, jwt, refresh_jwt, policies, user) => {
        const authenticated = !!session.token;
        const token_iat = jwt.payload ? sinceEpoch(jwt.payload.iat) : new Date();
        const token_expires = jwt.payload ? sinceEpoch(jwt.payload.exp) : new Date();
        const refresh_expires = refresh_jwt.payload ? sinceEpoch(refresh_jwt.payload.exp) : new Date();
        const server_offset = moment(token_iat).diff(session.tokenDate);
        const hasPolicy = search => !!policies.find(policy => policy.toLowerCase() === search.toLowerCase());
        return {...session, jwt, refresh_jwt, server_offset, token_expires, refresh_expires, policies, hasPolicy, authenticated, user};
    }
);
